import { NewStoryComponent } from './new/new.component';
import { UploadWizardStoryComponent } from './wizard/wizard.component';
import { ShowStoryComponent } from './show/show.component';
import { StoriesListComponent } from './list/list.component';
import { PrintStoryComponent } from './print/print.component';
import { OrdersComponent } from './orders/orders.component';
import { UploadProgressComponent } from './uploadProgress/uploadProgress.component';
import { CanActivateApp } from '../services/canActivateApp.service';
import { CanDeactivateShowStory } from 'app/services/can-deactivate-show-story.service';
import { CanDeactivateUploadWizardStory } from 'app/services/can-deactivate-upload-design-style.service';
import { CanDeactivateNewStory } from 'app/services/can-deactivate-new-story.service';
import { CanDeactivatePrintFlow } from 'app/+stories/print/can-deactivate-print-flow.service';
import { DesigningComponent } from './designing/designing.component';

export const routes = [
  {
    path: 'stories',
    component: StoriesListComponent,
    canActivate: [CanActivateApp],
  },
  {
    path: 'new',
    component: NewStoryComponent,
    children: [{ path: 'album', component: NewStoryComponent }],
    canActivate: [CanActivateApp],
    canDeactivate: [CanDeactivateNewStory],
  },
  {
    path: 'upload_wizard',
    component: UploadWizardStoryComponent,
    canActivate: [CanActivateApp],
    canDeactivate: [CanDeactivateUploadWizardStory],
  },
  {
    path: 'orders',
    component: OrdersComponent,
    canActivate: [CanActivateApp],
  },
  {
    path: 'uploading',
    component: UploadProgressComponent,
    canActivate: [CanActivateApp],
    data: {
      hideDefaultHeader: true,
    },
  },
  {
    path: 'designing',
    component: DesigningComponent,
    canActivate: [CanActivateApp],
  },
  {
    path: ':id',
    component: ShowStoryComponent,
    canDeactivate: [CanDeactivateShowStory],
    data: {
      hideDefaultHeader: true,
    },
  },
  {
    path: ':id/print',
    component: PrintStoryComponent,
    canDeactivate: [CanDeactivatePrintFlow],
  },
];
